import type { PublicPluginAPI } from '@atlaskit/editor-common/types';
import type { SelectionExtensionPlugin } from '@atlaskit/editor-plugin-selection-extension';

import type { ContentType } from '@atlassian/ai-issue-create';

import { convertSelectionToLegacyFormat } from '@confluence/highlight-actions/entry-points/convertSelectionToLegacyFormat.ts';
import {
	BULK_ISSUE_CREATE_SIDE_PANEL_ID,
	BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH,
} from '@confluence/issue-create-side-panel/entry-points/BulkCreateSidePanel.ts';
import type {
	IssueCreateSidePanelActions,
	PageMode,
} from '@confluence/issue-create-side-panel/entry-points/IssueCreateSidePanelContextProvider.ts';
import { openSingleIssueSidePanelWithSelection } from '@confluence/issue-create-side-panel/entry-points/singleCreateUtils.ts';
import type { RightSidebarContextType } from '@confluence/page-layout-context';
export interface CreateSingleJiraWorkItemHandleParams {
	rightSidebarContext: RightSidebarContextType;
	actions: IssueCreateSidePanelActions;
	activeSelection?: Selection | null;
	contentId?: string;
	contentType?: ContentType;
	container: HTMLElement | null;
	lastModified?: string | null;
	isCreatedWithAi?: boolean;
	isActionItemInSelection?: boolean;
	pageMode: PageMode;
	editorAPI: PublicPluginAPI<[SelectionExtensionPlugin]> | null | undefined;
}

export const createSingleJiraWorkItemHandle = ({
	rightSidebarContext,
	actions,
	activeSelection,
	contentId,
	contentType,
	container,
	lastModified,
	isActionItemInSelection,
	pageMode,
	editorAPI,
}: CreateSingleJiraWorkItemHandleParams) => {
	if (!contentId) {
		return;
	}

	if (editorAPI !== null && editorAPI !== undefined) {
		void actions.setEditorAPI(editorAPI);
		const selectionResult = editorAPI.selectionExtension?.actions?.getSelectionAdf?.();
		void actions.setSelectedAdf(selectionResult?.selectedNodeAdf ?? undefined);
	}

	openSingleIssueSidePanelWithSelection({
		actions,
		rightSidebarContext,
		activeSelection,
		contentId,
		contentType,
		container,
		lastModified,
		pageMode,
		isActionItemInSelection,
		convertSelectionToLegacyFormat,
	});
};

export interface CreateBulkJiraWorkItemsHandleParams {
	rightSidebarContext: RightSidebarContextType;
	actions: IssueCreateSidePanelActions;
	editorAPI: PublicPluginAPI<[SelectionExtensionPlugin]> | null | undefined;
}

export const createBulkJiraWorkItemsHandle = ({
	rightSidebarContext,
	actions,
	editorAPI,
}: CreateBulkJiraWorkItemsHandleParams) => {
	if (editorAPI !== null && editorAPI !== undefined) {
		void actions.setEditorAPI(editorAPI);
	}
	rightSidebarContext.open(BULK_ISSUE_CREATE_SIDE_PANEL_ID, BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH);
};
